import React from "react";

type Props = {
  className: string;
};

export default function CordRight({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="258"
      height="277"
      fill="none"
      className={className}
      preserveAspectRatio="xMidYMax meet"
      viewBox="0 0 258 277"
    >
      <path
        fill="#22304C"
        d="M258 .1c-3.9 1.3-14.2 3.4-18 5-21.7 8.8-39 21.8-50 37.7-14.6 21.3-18.2 46.4-21.6 70.7-1.2 8.3-2.3 17-4 25.1-4.5 22.2-15.1 53.5-40.4 76.1-22.1 19.7-52.7 28.3-78 21.3l-5 19.4a95 95 0 0023.8 3c25.6 0 51.8-10.1 72.7-28.7 29.3-26.4 41.5-61.8 46.6-87 1.7-8.7 3-17.6 4.2-26.3 3.2-23 6.3-44.8 18.2-62a91 91 0 0141.3-30.7c1.2-.4 9-1.7 10.3-2.1V0z"
      ></path>
      <path
        fill="#22304C"
        d="M.6 241.7V276h27.6a27.6 27.6 0 100-55.1H.6v20.8z"
      ></path>
    </svg>
  );
}
